import { ActionsUnion, createAction } from "store/helper";

export enum TicketActivityActionsNames {
  SET_AGENT_VIEWING = "FEATURE/TICKET_ACTIVITY/SET_AGENT_VIEWING",
  SET_AGENT_TYPING = "FEATURE/TICKET_ACTIVITY/SET_AGENT_TYPING",
  UNSET_AGENT_TYPING = "FEATURE/TICKET_ACTIVITY/UNSET_AGENT_TYPING",
  UNSET_AGENT_VIEWING = "FEATURE/TICKET_ACTIVITY/UNSET_AGENT_VIEWING",
}

export const TicketActivityActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setAgentViewing: (agentID: string, ticketID: string) =>
    createAction(TicketActivityActionsNames.SET_AGENT_VIEWING, { agentID, ticketID }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setAgentTyping: (agentID: string, ticketID: string) =>
    createAction(TicketActivityActionsNames.SET_AGENT_TYPING, { agentID, ticketID }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  unsetAgentViewing: (agentID: string, ticketID: string) =>
    createAction(TicketActivityActionsNames.UNSET_AGENT_VIEWING, { agentID, ticketID }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  unsetAgentTyping: (agentID: string, ticketID: string) =>
    createAction(TicketActivityActionsNames.UNSET_AGENT_TYPING, { agentID, ticketID }),
};

export type TicketActivityAction = ActionsUnion<typeof TicketActivityActions>;
